import { memo } from "react";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";
import { Nav } from "./components";
import SidebarFooter from "./components/SidebarFooter";
import SidebarHeader from "./components/SidebarHeader";
import SidebarContent from "./components/SidebarContent";

function Sidebar() {
  return (
    <ThemeProvider2024>
      <Nav>
        <SidebarHeader />
        <SidebarContent />
        <SidebarFooter />
      </Nav>
    </ThemeProvider2024>
  );
}

export default memo(Sidebar);
